var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"align-center loading-bar-wrapper"},[_vm._m(0),_c('span',{staticClass:"dp-block b"},[_vm._v(_vm._s(_vm.getMessage))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lds-bar"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }